module.exports = __webpack_public_path__ + "static/media/image027.4fe34f51.png";